import { Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { AuthGuard } from './guards/auth.guard';
import { SuperAdminGuard } from './guards/super-admin.guard';
import { CanWriteGuard } from './guards/can-write.guard';
import { NotfoundComponent } from './pages/notfound/notfound.component';

export const appRoutes: Routes = [
  {
    path: 'dashboard',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (c) => c.DashboardComponent,
          ),
      },
      {
        path: 'zeltplan',
        loadComponent: () =>
          import('./pages/zeltplan/zeltplan.component').then(
            (c) => c.ZeltPlanComponent,
          ),
      },
      {
        path: 'reservierungen',
        loadComponent: () =>
          import('./pages/kundenverwaltung/reservierungen/reservierungen.component').then(
            (c) => c.ReservierungenComponent,
          ),
      },
      {
        path: 'rechnungen',
        loadComponent: () =>
          import('./pages/kundenverwaltung/invoices/invoices.component').then(
            (c) => c.InvoicesComponent,
          ),
      },
      {
        path: 'kunden',
        loadComponent: () =>
          import('./pages/kundenverwaltung/kundenuebersicht/kundenuebersicht.component').then(
            (c) => c.KundenUebersichtComponent,
          ),
      },
      {
        path: 'kunde-edit/:customerId',
        loadComponent: () =>
          import('./pages/kundenverwaltung/kunde-edit/kunde-edit.component').then(
            (c) => c.KundeEditComponent,
          ),
      },
      {
        path: 'kunde-edit/:customerId/:tabindex',
        loadComponent: () =>
          import('./pages/kundenverwaltung/kunde-edit/kunde-edit.component').then(
            (c) => c.KundeEditComponent,
          ),
      },
      {
        path: 'anfragen',
        loadComponent: () =>
          import('./pages/kundenverwaltung/anfragen/anfragen.component').then(
            (c) => c.AnfragenComponent,
          ),
      },
      {
        path: 'kunden-duplikate',
        loadComponent: () =>
          import('./pages/kundenverwaltung/kunden-duplikate/kunden-duplikate.component').then(
            (c) => c.KundenDuplikateComponent,
          ),
      },
      {
        path: 'versandlisten',
        loadComponent: () =>
          import('./pages/export-druck/dhl-versandlisten/dhl-versandlisten.component').then(
            (c) => c.DhlVersandlistenComponent,
          ),
        canActivate: [CanWriteGuard],
      },
      {
        path: 'tischkarten',
        loadComponent: () =>
          import('./pages/export-druck/table-cards/table-cards.component').then(
            (c) => c.TableCardsComponent,
          ),
        canActivate: [CanWriteGuard],
      },
      {
        path: 'exportlisten',
        loadComponent: () =>
          import('./pages/export-druck/exportlists/exportlists.component').then(
            (c) => c.ExportlistsComponent,
          ),
        canActivate: [CanWriteGuard],
      },
      {
        path: 'fest-produktauswertung',
        loadComponent: () =>
          import('./pages/auswertungen/fest-produktauswertung/fest-produktauswertung.component').then(
            (c) => c.FestProduktauswertungComponent,
          ),
      },
      {
        path: 'festival-stats',
        loadComponent: () =>
          import('./pages/auswertungen/festival-stats/festival-stats.component').then(
            (c) => c.FestivalStatsComponent,
          ),
      },
      {
        path: 'festival-summary',
        loadComponent: () =>
          import('./pages/auswertungen/festival-summary/festival-summary.component').then(
            (c) => c.FestivalSummaryComponent,
          ),
      },
      {
        path: 'fest-kundengruppen',
        loadComponent: () =>
          import('./pages/auswertungen/fest-kundengruppen/fest-kundengruppen.component').then(
            (c) => c.FestKundengruppenComponent,
          ),
      },
      {
        path: 'fest-reservierungen',
        loadComponent: () =>
          import('./pages/auswertungen/fest-reservierungen/fest-reservierungen.component').then(
            (c) => c.FestReservierungenComponent,
          ),
      },
      {
        path: 'top-100-kunden',
        loadComponent: () =>
          import('./pages/auswertungen/top-100-kunden/top-100-kunden.component').then(
            (c) => c.Top100KundenComponent,
          ),
      },
      {
        path: 'produkte',
        loadComponent: () =>
          import('./pages/produktverwaltung/produkte/produkte.component').then(
            (c) => c.ProdukteComponent,
          ),
      },
      {
        path: 'pakete',
        loadComponent: () =>
          import('./pages/produktverwaltung/pakete/pakete.component').then(
            (c) => c.PaketeComponent,
          ),
      },
      {
        path: 'auftragsrabatt',
        loadComponent: () =>
          import('./pages/produktverwaltung/auftragsrabatt/auftragsrabatt.component').then(
            (c) => c.AuftragsrabattComponent,
          ),
      },
      {
        path: 'auftragsrabatt-edit/:discountId',
        loadComponent: () =>
          import('./pages/produktverwaltung/auftragsrabatt/auftragsrabatt-edit/auftragsrabatt-edit.component').then(
            (c) => c.AuftragsrabattEditComponent,
          ),
      },
      {
        path: 'versandoptionen',
        loadComponent: () =>
          import('./pages/produktverwaltung/deliveryoptions/deliveryoptions.component').then(
            (c) => c.DeliveryoptionsComponent,
          ),
      },
      {
        path: 'geldrabatte',
        loadComponent: () =>
          import('./pages/produktverwaltung/money-discounts/money-discounts.component').then(
            (c) => c.MoneyDiscountsComponent,
          ),
      },
      {
        path: 'codewoerter',
        loadComponent: () =>
          import('./pages/produktverwaltung/codewoerter/codewoerter.component').then(
            (c) => c.CodewoerterComponent,
          ),
      },
      {
        path: 'feste',
        loadComponent: () =>
          import('./pages/festverwaltung/feste/feste.component').then(
            (c) => c.FesteComponent,
          ),
      },
      {
        path: 'feste-edit/:festivalId',
        loadComponent: () =>
          import('./pages/festverwaltung/feste-edit/feste-edit.component').then(
            (c) => c.FesteEditComponent,
          ),
      },
      {
        path: 'bereiche',
        loadComponent: () =>
          import('./pages/festverwaltung/logen/logen.component').then(
            (c) => c.LogenComponent,
          ),
      },
      {
        path: 'bereich-edit/:id',
        loadComponent: () =>
          import('./pages/festverwaltung/logen-edit/logen-edit.component').then(
            (c) => c.LogenEditComponent,
          ),
      },
      {
        path: 'bereichegrid',
        loadComponent: () =>
          import('./pages/festverwaltung/bereichegrid/bereichegrid.component').then(
            (c) => c.BereichegridComponent,
          ),
      },
      {
        path: 'tage',
        loadComponent: () =>
          import('./pages/festverwaltung/tage/tage.component').then(
            (c) => c.TageComponent,
          ),
      },
      {
        path: 'log-buecher',
        loadComponent: () =>
          import('./pages/festverwaltung/log-buecher/log-buecher.component').then(
            (c) => c.LogBuecherComponent,
          ),
      },
      {
        path: 'bank-sync',
        loadComponent: () =>
          import('./pages/kundenverwaltung/bank-sync/bank-sync.component').then(
            (c) => c.BankSyncComponent,
          ),
      },
      {
        path: 'support',
        loadComponent: () =>
          import('./pages/support/support.component').then(
            (c) => c.SupportComponent,
          ),
      },
      {
        path: 'email-templates',
        loadComponent: () =>
          import('./pages/vorlagen/email-templates/email-templates.component').then(
            (c) => c.EmailTemplatesComponent,
          ),
      },
      {
        path: 'profil',
        loadComponent: () =>
          import('./pages/profile/profile.component').then(
            (c) => c.ProfileComponent,
          ),
      },
      {
        path: 'spa-wartung',
        loadComponent: () =>
          import('./pages/einstellungen/spa-maintenance/spa-maintenance.component').then(
            (c) => c.SpaMaintenanceComponent,
          ),
        canActivate: [CanWriteGuard],
      },
      {
        path: 'administratoren',
        loadComponent: () =>
          import('./pages/administratoren/administratoren.component').then(
            (c) => c.AdministratorenComponent,
          ),
        canActivate: [SuperAdminGuard],
      },
    ],
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then(
            (c) => c.LoginComponent,
          ),
      },
      { path: '**', redirectTo: '/notfound' },
    ],
  },
  { path: 'notfound', component: NotfoundComponent },
  {
    path: 'debug-page',
    loadComponent: () =>
      import('./pages/test-error/test-error.component').then(
        (c) => c.TestErrorComponent,
      ),
  },
  { path: '**', redirectTo: '/auth/login' },
];
